<div class="py-3">
  <div class="flex">
    <custom-label [placeholder]="placeholder"></custom-label>
    <div *ngIf="isRequired" class="text-red-500 ml-1 mt-1">*</div>
  </div>
      <span class="p-input-icon-left" >
          <textarea
            border-round pInputText
            [formControl]="value"
            (blur)="onTouch()"
            [rows]="rows"
          >
          {{value}}
          </textarea>
      </span>
      <span *ngIf="form && isValidField()" class="block mt-3 ml-5 text-red-500 font-italic display-6">{{errorField()}}</span>

<div >
